<template>
  <div class="product-page">
    <nav-tab></nav-tab>
    <div class="page_1">
      <video src="https://global-cdn.imscv.com/tewamoto/tewamoto-s_compressed.mp4" autoplay loop muted playsinline
        preload="auto">
      </video>
    </div>
    <div class="page_2">
      <img src="https://global-cdn.imscv.com/tewamoto/v3/M3%20SERIES-2.jpg" alt="" v-if="$isPC">
      <img src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-2.jpg" alt="" v-else />
      <div class="text_content" v-if="$isPC">
        <div>Pro Power System</div>
      </div>
    </div>
    <div class="page_3">
      <img src="https://global-cdn.imscv.com/tewamoto/v3/M3%20SERIES-3.jpg" alt="" v-if="$isPC">
      <img src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-3.jpg" alt="" v-else />
      <div class="text_content" v-if="$isPC">
        <div class="content left">
          <div>
            <div class="t1">
              <span>2.0</span><span>s</span>
            </div>
            <div class="t2">0~30 mph acceleration</div>
          </div>
          <div>
            <div class="t1">
              <span>80</span><span>miles</span>
            </div>
            <div class="t2">Range</div>
          </div>
        </div>
        <div class="content right">
          <div>
            <div class="t1">
              <span>720</span><span>N.m</span>
            </div>
            <div class="t2">On wheel torque</div>
          </div>
          <div>
            <div class="t1">
              <span>60</span><span>mph</span>
            </div>
            <div class="t2">Top Speed</div>
          </div>
        </div>
      </div>
      <div class="text_content" v-else>
        <div class="title">Pro Power System</div>
        <div class="text_box">
          <div class="content left">
            <div class="mb">
              <div class="t1">
                <span>2.0</span><span>s</span>
              </div>
              <div class="t2">0~30 mph acceleration</div>
            </div>
            <div>
              <div class="t1">
                <span>80</span><span>miles</span>
              </div>
              <div class="t2">Range</div>
            </div>
          </div>
          <div class="content right">
            <div class="mb">
              <div class="t1">
                <span>720</span><span>N.m</span>
              </div>
              <div class="t2">On wheel torque</div>
            </div>
            <div>
              <div class="t1">
                <span>60</span><span>mph</span>
              </div>
              <div class="t2">Top Speed</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_4" v-if="$isPC">
      <img src="https://global-cdn.imscv.com/tewamoto/v3/M3%20SERIES-4.jpg" alt="">
      <div class="text_content">
        <div class="text_box">
          <div class="t1">Swappable Battery</div>
          <div v-for="(item,index) in page4lt" :key="index" class="t2_box">
            <div class="t2">
              <span class="t2_1">{{item.t2_1}}</span><span class="t2_2">{{item.t2_2}}</span>
            </div>
            <div class="t3">{{item.t3}}</div>
          </div>
        </div>
        <div class="text_box">
          <div class="t1">Hairpin Motor</div>
          <div v-for="(item,index) in page4rt" :key="index" class="t2_box">
            <div class="t2 rt_t2">
              <span class="t2_1">{{item.t2_1}}</span><span class="t2_2">{{item.t2_2}}</span>
            </div>
            <div class="t3">{{item.t3}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="page_4" v-else>
      <div class="left">
        <div class="t1">Swappable Battery</div>
        <div v-for="(item,index) in page4lt" :key="index" class="t2_box">
          <div class="t2">
            <span class="t2_1">{{item.t2_1}}</span><span class="t2_2">{{item.t2_2}}</span>
          </div>
          <div class="t3">{{item.t3}}</div>
        </div>
      </div>
      <div class="right">
        <img src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-4.jpg" alt="" />
      </div>
    </div>
    <div class="page_4_2" v-if="$isMobile">
      <div class="left">
        <img src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-5.jpg" alt="">
      </div>
      <div class="right">
        <div class="t1">Hairpin Motor</div>
        <div v-for="(item,index) in page4rt" :key="index" class="t2_box">
          <div class="t2 rt_t2">
            <span class="t2_1">{{item.t2_1}}</span><span class="t2_2">{{item.t2_2}}</span>
          </div>
          <div class="t3">{{item.t3}}</div>
        </div>
      </div>
    </div>
    <div class="page_5">
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/M3%20SERIES-5.jpg" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-6.jpg" alt="" />
      <div class="text_content">
        <div class="t1">Pro Frame</div>
        <div class="t2">Seamless chromoly <br /> Double wing cage </div>
        <div class="t3">
          <div><span class="t3_1">16</span><span class="t3_2">CrMn</span></div>
          <div><span class="t3_1">σs≥740</span><span class="t3_2">MPa</span></div>
        </div>
      </div>
    </div>

    <div class="page_6">
      <div class="t1">Pro Suspension</div>
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/M3%20SERIES-6.jpg" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-7.jpg" alt="" />
      <div class="text_content">
        <div class="t2">
          <div class="t2_1">L442-Ø16</div>
          <div class="t2_2" v-if="$isPC">Travel 4 inch / 95 mm</div>
          <div class="t2_2" v-else>Travel 4 inch /<br /> 95 mm</div>
        </div>
        <div class="t2" v-if="$isPC">
          <div class="t2_1">L800 Ø46*Ø38 </div>
          <div class="t2_2">Travel 8 inch / 195 mm</div>
        </div>
      </div>
    </div>
    <div class="page_6_2" v-if="$isMobile">
      <img src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-8.jpg" alt="">
      <div class="t2">
        <div class="t2_1">L800 Ø46*Ø38 </div>
        <div class="t2_2">Travel 8 inch / 195 mm</div>
      </div>
    </div>
    <div class="page_7_t1" v-if="$isPC">Pro Brake Pads</div>
    <div class="page_7">
      <img v-if="$isPC" src="https://global-cdn.imscv.com/tewamoto/v3/M3%20SERIES-7.jpg" alt="">
      <img v-else src="https://global-cdn.imscv.com/tewamoto/mobile-v3/M3%20SERIES-9.jpg" alt="">
      <div class="title" v-if="$isMobile">Pro Brake Pads</div>
      <div class="text_content">
        <div class="text_box">
          <div>
            <span class="t2_1">Ø 200</span><span class="t2_2">mm</span>
          </div>
          <div class="t3">4 mm thickness</div>
        </div>
        <div class="text_box">
          <div>
            <span class="t2_1">Ø 270</span><span class="t2_2">mm</span>
          </div>
          <div class="t3">3 mm thickness</div>
        </div>
      </div>
    </div>
    <div class="page_8">
      <div class="title">
        <div></div>
        <div>Type</div>
        <div>Parameter</div>
        <div></div>
      </div>
      <div class="text_1_box">
        <div></div>
        <div class="t1">Vehicle Mode</div>
        <div class="t2">M3 Pro Electric Off-Road</div>
        <div></div>
      </div>
      <div class="text_1_box">
        <div></div>
        <div class="t1">Vehicle Enduro & Entry Motocross</div>
        <div class="t2">Enduro & Entry Motocross</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Vehicle</div>
        <div class="t2">Motor Type</div>
        <div class="t3">PMSM Motor</div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Frame</div>
        <div class="t2">Type</div>
        <div class="t3">Double wing cage</div>
        <div></div>
      </div>
      <div class="text_2_box">
        <div class="t1"></div>
        <div class="t2">Materia</div>
        <div class="t3">Chromoly Steel</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Suspension</div>
        <div class="t2">Brand</div>
        <div class="t3">Fastace</div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList2" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Tire</div>
        <div class="t2">Type</div>
        <div class="t3">Off road tires</div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList3" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Brake</div>
        <div class="t2">Front Brakes</div>
        <div class="t3">Φ10.6 inch - 0.11 inch</div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList4" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Handlebar</div>
        <div class="t2">Material</div>
        <div class="t3">TPE</div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList5" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Drive Modes</div>
        <div class="t2">Reverse</div>
        <div class="t3"></div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList6" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Display</div>
        <div class="t2">Display type</div>
        <div class="t3">4.3" TFT Color Screen</div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList7" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
      <div class="text_2_box">
        <div class="t1">Parameter</div>
        <div></div>
      </div>
      <div class="text_2_box" v-for="(item,index) in configList8" :key="item.t3+index">
        <div></div>
        <div class="t2">{{item.t2}}</div>
        <div class="t3">{{item.t3}}</div>
        <div></div>
      </div>
      <hr class="hr1" />
    </div>
    <footerTemp></footerTemp>
  </div>
</template>

<script>
  import navTab from '@/components/navTab.vue'
  import footerTemp from '@/components/footer.vue'
  export default {
    name: 'M3SERIES',
    components: {
      navTab,
      footerTemp
    },
    data () {
      return {
        page4lt: [
          {
            t2_1: '21',
            t2_2: 'Kw',
            t3: 'Max Discharge Power',
          },
          {
            t2_1: '84',
            t2_2: 'V',
            t3: 'Peak Voltage',
          },
          {
            t2_1: '1',
            t2_2: 'C',
            t3: 'Max Charging Rate',
          },
        ],
        page4rt: [
          {
            t2_1: '10.5',
            t2_2: 'Kw',
            t3: 'Rated',
          },
          {
            t2_1: '21',
            t2_2: 'Kw',
            t3: 'Peak',
          },
          {
            t2_1: '8000',
            t2_2: '',
            t3: 'rpm max'
          }
        ],
        configList: [
          { t2: "Battery", t3: "NCM Lithium 72 V 50 Ah" },
          { t2: "Peak Power", t3: "21 kW" },
          { t2: "Maximum Torque", t3: "720 N·m" },
          { t2: "Rated Power", t3: "10.5 kW" },
          { t2: "Maximum Range @ 25mph", t3: "80 Miles" },
          { t2: "Max Grade Ability", t3: "40°" },
          { t2: "Acceleration time from 0–30km/h", t3: "2.0 s" },
          { t2: "Front-Rear Weight Distribution", t3: "1:1" },
          { t2: "Motor Protection Level", t3: "IP67" },
          { t2: "Length*Width*Height", t3: "82 x 32 x 46 inch" },
          { t2: "Seat Height", t3: "35 inch" },
          { t2: "Ground Clearance", t3: "13 inch" },
          { t2: "Wheelbase", t3: "55 inch" },
          { t2: "Curb Weight", t3: "242 lbs" },
          { t2: "Maximum Load", t3: "330 lbs" }
        ],
        configList2: [
          { t2: "Fork", t3: "L800 -046*Ø38" },
          { t2: "Damping Adjustment", t3: "Petal Shaped Manual Damping Adjustable Knob" },
          { t2: "Front Shock Travel", t3: "8 inch" },
          { t2: "Rear Shock Absorber", t3: "L442 Ø16" },
          { t2: "Rear Shock Travel", t3: "4 inch" }
        ],
        configList3: [
          { t2: "Rim", t3: "Aluminum alloy spoke structure" },
          { t2: "Front Tire", t3: "80/100-21" },
          { t2: "Rear Tire", t3: "110/90-18" }
        ],
        configList4: [
          { t2: "Rear Brakes", t3: "Φ9.4 inch - 0.16 inch" },
          { t2: "Material", t3: "12Cr13 martensitic high-temperature steel" },
          { t2: "Pattern", t3: "Sun pattern ventilation disc" }
        ],
        configList5: [
          { t2: "Protection Level", t3: "IP66" },
          { t2: "Throttle Rotation Angle", t3: "65°" }
        ],
        configList6: [
          { t2: "ECO", t3: "" },
          { t2: "Trail", t3: "Customizable with APP" },
          { t2: "Sport", t3: "" }
        ],
        configList7: [
          { t2: "Brightness", t3: "1200 cd/m²" },
          { t2: "Protection Level", t3: "IP66" }
        ],
        configList8: [
          { t2: "Motor Type", t3: "PMSM Motor" },
          { t2: "Battery", t3: "NCM Lithium 72 V 50 Ah" },
          { t2: "Peak Power", t3: "21kW" },
          { t2: "Maximum Torque", t3: "720 N.m" },
          { t2: "Rated Power", t3: "10.5 kW" },
          { t2: "Maximum Range @ 25mph", t3: "80 Miles" },
          { t2: "Max Grade Ability", t3: "40°" },
          { t2: "Acceleration time from 0~30 mph", t3: "2.0s" },
          { t2: "Front-Rear Weight Distribution", t3: "1:1" },
          { t2: "Motor Protection Level", t3: "IP67" },
          { t2: "Length*Width*Height", t3: "84 x 32 x 47 inch" },
          { t2: "Seat Height", t3: "35 inch" },
          { t2: "Ground Clearance", t3: "13 inch" },
          { t2: "Wheelbase", t3: "58 inch" },
          { t2: "Curb Weight", t3: "240lbs" },
          { t2: "Maximum Load", t3: "330 lbs" },
          { t2: "Type", t3: "Double wing cage" },
          { t2: "Materia", t3: "Chromoly Steel" },
          { t2: "Brand", t3: "Fastace" },
          { t2: "Fork", t3: "L880-Φ52*Φ43" },
          { t2: "Damping adjustment", t3: "Petal Shaped Manual Damping Adjustable Knob" },
          { t2: "Front Shock Travel", t3: "9 inch" },
          { t2: "Rear Shock Absorber", t3: "L455Φ16" },
          { t2: "Rear Shock Travel", t3: "4 inch" },
          { t2: "Type", t3: "Off road tires" },
          { t2: "Rim", t3: "Aluminum alloy spoke structure" },
          { t2: "Front Tire", t3: "80/100-21" },
          { t2: "Rear Tire", t3: "110/90-18" },
          { t2: "Front Brakes", t3: "Φ10.6 inch -0.12 inch" },
          { t2: "Rear Brakes", t3: "Φ9.4inch -0.16 inch" }
        ]
      }
    },
    mounted () {
      window.scrollTo(0, 0)

    },
    methods: {

    }
  }
</script>

<style scoped lang="scss">
  img {
    display: block;
  }

  @media (max-width: 768px) {
    .product-page {
      background: #000;
      font-size: 18px;

      .page_1 {
        width: 100vw;
        height: 100vh;

        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .page_2 {
        width: 100%;

        img {
          width: 100%;
        }
      }

      .page_3 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: 100%;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          padding-top: 45px;
          box-sizing: border-box;

          .title {
            width: 100%;
            text-align: center;
            color: #FFA400;
            font-size: 30px;
            font-family: "AlibabaPuHuiTi";
            font-weight: bold;
          }

          .text_box {
            display: flex;
            justify-content: space-around;
            margin-top: 20px;

            .content {
              .t1 {
                font-family: "DINPro";

                span:first-child {
                  font-size: 30px;
                }

                span:last-child {
                  font-size: 16px;
                }
              }

              .t2 {
                font-family: "AlibabaPuHuiTi";
                font-size: 10px;
              }

              .mb {
                margin-bottom: 20px;
              }

              &:first-child {
                margin-left: 40px;
              }

              &:last-child {
                margin-right: 40px;
              }
            }
          }
        }
      }

      .page_4 {
        width: 100%;
        padding-top: 50px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;

        .left {
          flex: 1;
          color: #fff;

          .t1 {
            color: #000;
            background-color: #FFA400;
            display: inline-block;
            font-size: 16px;
            font-family: "AlibabaPuHuiTi";
            font-weight: 900;
            padding: 4px 20px;
            margin-left: 14px;
            margin-bottom: 20px;
            box-sizing: border-box;
          }

          .t2_box {
            margin-left: 14px;
            margin-top: 10px;
            display: flex;
            align-items: center;

            .t2 {
              font-family: "DINPro";
              width: 30%;

              .t2_1 {
                font-size: 22px;
              }

              .t2_2 {
                font-size: 14px;
              }
            }

            .t3 {
              font-size: 10px;
              font-family: "AlibabaPuHuiTi";
              margin-right: 14px;
            }
          }
        }

        .right {
          flex: 1;

          img {
            width: 100%;
            height: auto;
          }
        }
      }

      .page_4_2 {
        padding-top: 50px;
        width: 100%;
        display: flex;
        box-sizing: border-box;

        .left {
          flex: 1;

          img {
            width: 100%;
            height: auto;
          }
        }

        .right {
          flex: 1;
          color: #fff;

          .t1 {
            color: #000;
            background-color: #FFA400;
            display: inline-block;
            font-size: 16px;
            font-family: "AlibabaPuHuiTi";
            font-weight: 900;
            padding: 4px 16px;
            margin-left: 33px;
            margin-bottom: 20px;
            box-sizing: border-box;
          }

          .t2_box {
            margin-left: 33px;
            margin-top: 10px;
            display: flex;
            align-items: center;

            .t2 {
              font-family: "DINPro";
              width: 40%;

              .t2_1 {
                font-size: 22px;
              }

              .t2_2 {
                font-size: 14px;
              }
            }

            .t3 {
              font-size: 10px;
              font-family: "AlibabaPuHuiTi";
              margin-right: 14px;
            }
          }
        }
      }

      .page_5 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          text-align: center;

          .t1 {
            margin-top: 50px;
            font-size: 30px;
            color: #FFA400;
            font-family: "AlibabaPuHuiTi";
            font-weight: 900;
          }

          .t2 {
            margin-top: 10px;
            font-size: 16px;
            font-weight: "AlibabaPuHuiTi";
            font-weight: 600;
          }

          .t3 {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            margin-top: 20px;
            font-family: "DINPro";

            .t3_1 {
              font-size: 30px;
            }

            .t3_2 {
              font-size: 16px;
            }
          }
        }
      }

      .page_6 {
        width: 100%;
        position: relative;
        padding: 0 20px;
        box-sizing: border-box;

        .t1 {
          font-size: 30px;
          font-family: "AlibabaPuHuiTi";
          font-weight: 900;
          text-align: center;
          color: #FFA400;
          padding: 40px 0;
          box-sizing: border-box;
        }

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .t2 {
            margin-right: 50px;

            .t2_1 {
              font-size: 22px;
              font-family: "DINPro";
            }

            .t2_2 {
              font-size: 12px;
              font-family: "AlibabaPuHuiTi";
              font-weight: 500;
            }
          }
        }
      }

      .page_6_2 {
        width: 100%;
        position: relative;
        padding: 0 20px;
        box-sizing: border-box;
        margin-top: 20px;

        img {
          width: 100%;
          height: auto;
        }

        .t2 {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          padding: 50px 0 0 50px;
          box-sizing: border-box;

          .t2_1 {
            font-size: 22px;
            font-family: "DINPro";
          }

          .t2_2 {
            font-size: 12px;
            font-family: "AlibabaPuHuiTi";
            font-weight: 500;
          }
        }
      }

      .page_7 {
        width: 100%;
        position: relative;
        margin-top: 50px;
        box-sizing: border-box;

        img {
          width: 100%;
          height: auto;
        }

        .title {
          width: 100%;
          text-align: center;
          font-size: 30px;
          color: #FFA400;
          font-family: "AlibabaPuHuiTi";
          font-weight: 900;
          position: absolute;
          left: 0;
          top: 0;
          margin-top: 50px;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          gap: 40px;
          display: flex;
          justify-content: center;
          color: #fff;
          padding-top: 120px;
          box-sizing: border-box;

          .t2_1 {
            font-size: 30px;
            font-family: "DINPro";
          }

          .t2_2 {
            font-size: 16px;
            font-family: "DINPro";
          }

          .t3 {
            font-size: 14px;
            font-family: "AlibabaPuHuiTi";
            font-weight: 500;
          }
        }
      }

      .page_8 {
        width: 100%;
        background-color: #191919;
        padding: 48px 14px 10px;
        box-sizing: border-box;

        .title {
          width: 100%;
          display: flex;
          background-color: #FFA400;
          font-family: "AlibabaPuHuiTi";
          font-weight: 900;
          padding: 4px 0;
          font-size: 12px;
          margin-bottom: 10px;

          div {
            flex: 1;

            &:nth-child(2) {
              flex: 1.5;
            }

            &:nth-child(3) {
              flex: 1.5;
            }

            &:nth-child(4) {
              flex: 0.5;
            }
          }
        }

        .text_1_box {
          width: 100%;
          display: flex;

          div {
            flex: 1;
            font-family: "AlibabaPuHuiTi";
            font-size: 8px;
            line-height: 25px;

            &:nth-child(2) {
              flex: 1.5;
            }

            &:nth-child(3) {
              flex: 1.5;
            }

            &:nth-child(4) {
              flex: 0.5;
            }
          }

          .t1 {
            color: #B2B2B2;
            font-weight: 500;
          }

          .t2 {
            color: #fff;
            font-weight: 800;
          }
        }

        .hr1 {
          margin: 10px 0;
          border: none;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          background-color: rgba(255, 255, 255, 0.2);
        }

        .text_2_box {
          display: flex;
          align-items: flex-end;

          div {
            flex: 1;
            font-family: "AlibabaPuHuiTi";
            font-size: 8px;
            line-height: 25px;

            &:nth-child(2) {
              flex: 1.5;
            }

            &:nth-child(3) {
              flex: 1.5;
            }

            &:nth-child(4) {
              flex: 0.5;
            }
          }

          .t1 {
            font-size: 12px;
            color: #fff;
          }

          .t2 {
            color: #B2B2B2;
            font-weight: 500;
          }

          .t3 {
            color: #fff;
            font-weight: 800;
          }
        }
      }
    }
  }

  @media (min-width: 769px) {
    .product-page {
      background: #000;
      font-size: 18px;

      .page_1 {
        width: 100%;
        height: 100vh;

        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .page_2 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: flex-end;
          font-size: 62.5px;
          color: #FFA400;
          font-family: AlibabaPuHuiTi_3_105_Heavy;
          font-weight: bold;

          div {
            margin-bottom: 47.22px;
          }
        }
      }

      .page_3 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          display: flex;
          justify-content: space-around;
          align-items: center;

          .content {
            width: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            column-gap: 88.20px;

            .t1 {
              font-family: "DINPro", sans-serif;
              font-weight: bold;

              span:first-child {
                font-size: 77px;
              }

              span:last-child {
                font-size: 36.11px;
              }
            }

            .t2 {
              font-family: "AlibabaPuHuiTi_3_65_Medium";
            }
          }
        }
      }

      .page_4 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          padding-top: 37px;
          /* PC 宽屏：文字左边界对齐 1440px 内容容器 */
          padding-left: max(98.61px, calc((100% - 1440px) / 2));
          box-sizing: border-box;

          .text_box {
            flex: 1;
            color: #fff;

            .t1 {
              font-size: 34.72px;
              background-color: #FFA500;
              font-family: "AlibabaPuHuiTi_3_105_Heavy";
              color: #000;
              font-weight: 900;
              display: inline-block;
              padding: 8px 24px;
              box-sizing: border-box;
              cursor: pointer;
            }

            .t2_box {
              margin-top: 10px;
              display: flex;
              gap: 16px;
              align-items: center;

              .t2 {
                font-family: "DINPro";
                font-weight: bold;
                width: 12%;

                .t2_1 {
                  font-size: 41.66px;
                }
              }

              .rt_t2 {
                width: 18%;
              }

              .t3 {
                font-size: 13.88px;
                font-family: "AlibabaPuHuiTi", sans-serif;
              }
            }
          }
        }
      }

      .page_5 {
        width: 100%;
        padding: 148px 98px;
        box-sizing: border-box;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          /* PC 宽屏：左右内缩对齐 1440px 内容容器 */
          padding: 254px max(172px, calc((100% - 1440px) / 2));
          box-sizing: border-box;

          .t1 {
            font-family: "AlibabaPuHuiTi", sans-serif;
            font-size: 62.5px;
            color: #FFA400;
            font-weight: 900;
          }

          .t2 {
            font-family: "AlibabaPuHuiTi", sans-serif;
            font-size: 34.72px;
            color: #000000;
            line-height: 40px;
          }

          .t3 {
            font-family: "DINPro", sans-serif;
            display: flex;
            align-items: center;
            gap: 40px;
            margin-top: 70px;

            .t3_1 {
              font-size: 41.66px;
            }

            .t3_2 {
              font-size: 24.30px;
            }
          }
        }
      }

      .page_6 {
        width: 100%;
        position: relative;

        .t1 {
          font-family: "AlibabaPuHuiTi", sans-serif;
          color: #FFA400;
          font-size: 61.5px;
          font-weight: 900;
          text-align: center;
          padding-bottom: 61.11px;
          box-sizing: border-box;
        }

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          gap: 100px;
          padding-top: 240px;
          box-sizing: border-box;

          .t2_1 {
            font-size: 41.66px;
            font-family: "DINPro";
            font-weight: bold;
            text-align: left;
          }

          .t2_2 {
            font-size: 20.83px;
            font-family: "AlibabaPuHuiTi";
          }

          .t2:last-child {
            position: relative;
            left: 30px;
          }
        }
      }

      .page_7_t1 {
        text-align: center;
        font-size: 62.5px;
        font-family: "AlibabaPuHuiTi";
        font-weight: 900;
        color: #FFA400;
        padding: 66.66px 0;
      }

      .page_7 {
        width: 100%;
        position: relative;

        img {
          width: 100%;
          height: auto;
        }

        .text_content {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          display: flex;
          justify-content: space-between;
          align-items: center;
          paading: 0 121.52px;

          .text_box {
            .t2_1 {
              font-family: "DINPro";
              font-size: 41.66px;
            }

            .t2_2 {
              font-family: "DINPro";
              font-size: 24.3px;
            }

            .t3 {
              font-family: "AlibabaPuHuiTi";
              font-size: 20.83px;
            }

            &:first-child {
              position: relative;
              left: 121.52px;
            }

            &:last-child {
              position: relative;
              right: 121.52px;
            }
          }
        }
      }

      .page_8 {
        width: 100%;
        background-color: #191919;
        /* PC 宽屏：参数表格压在 1440px 内居中，避免宽屏拉满可读性差 */
        padding: 129.86px max(98.61px, calc((100% - 1440px) / 2)) 50px;
        box-sizing: border-box;

        .title {
          width: 100%;
          display: flex;
          background-color: #FFA400;
          font-family: "AlibabaPuHuiTi";
          font-weight: 900;
          padding: 4px 0;
          font-size: 31.25px;
          margin-bottom: 20px;

          div {
            flex: 1;

            &:nth-child(2) {
              flex: 1.5;
            }

            &:nth-child(3) {
              flex: 1.5;
            }

            &:nth-child(4) {
              flex: 0.5;
            }
          }
        }

        .text_1_box {
          width: 100%;
          display: flex;

          div {
            flex: 1;
            font-family: "AlibabaPuHuiTi";
            font-size: 13.88px;
            line-height: 25px;

            &:nth-child(2) {
              flex: 1.5;
            }

            &:nth-child(3) {
              flex: 1.5;
            }

            &:nth-child(4) {
              flex: 0.5;
            }
          }

          .t1 {
            color: #B2B2B2;
            font-weight: 500;
          }

          .t2 {
            color: #fff;
            font-weight: 800;
          }
        }

        .hr1 {
          margin: 20px 0;
          border: none;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          background-color: rgba(255, 255, 255, 0.2);
        }

        .text_2_box {
          display: flex;
          align-items: flex-end;

          div {
            flex: 1;
            font-family: "AlibabaPuHuiTi";
            font-size: 13.88px;
            line-height: 25px;

            &:nth-child(2) {
              flex: 1.5;
            }

            &:nth-child(3) {
              flex: 1.5;
            }

            &:nth-child(4) {
              flex: 0.5;
            }
          }

          .t1 {
            font-size: 31.25px;
            color: #fff;
          }

          .t2 {
            color: #B2B2B2;
            font-weight: 500;
          }

          .t3 {
            color: #fff;
            font-weight: 800;
          }
        }
      }
    }
  }
</style>